import "./DropdownMenu.css";
import { useState } from "react";
import { ReactComponent as Caret } from "./caret.svg";
import { NavLink } from "react-router-dom";

const DropdownMenu = ({ title, links, isMobile, onClick }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div
            className="dropdown"
            onClick={() => setIsOpen((prev) => !prev)}
            onMouseEnter={!isMobile ? () => setIsOpen(true) : undefined}
            onMouseLeave={!isMobile ? () => setIsOpen(false) : undefined}
        >
            <div className={isOpen ? "dropdown-toggle open" : "dropdown-toggle"}>
                <span>{title}</span> <Caret />
            </div>
            {isOpen && (
                <div className="dropdown-menu">
                    {links.map((link, index) => {
                        if (link.path.startsWith("/")) {
                            return (
                                <NavLink
                                    key={index}
                                    to={link.path}
                                    className={({ isActive }) => (isActive ? "active" : "")}
                                    onClick={onClick || undefined}
                                >
                                    {link.label}
                                </NavLink>
                            );
                        } else if (link.path.startsWith("https://helios.win")) {
                            return (
                                <a key={index} href={link.path}>
                                    {link.label}
                                </a>
                            );
                        } else {
                            return (
                                <a key={index} href={link.path} target="_blank" rel="noopener noreferrer">
                                    {link.label}
                                </a>
                            );
                        }
                    })}
                </div>
            )}
        </div>
    );
};

export default DropdownMenu;
